import { CoreUiException } from "./core-ui-exception";

/**
 * Occurs when trying to create a record with the specified id already exists.
 */
export class RecordExistsException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("RecordExistsException", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, RecordExistsException.prototype);
    }
}
